"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIframePidgetPromptBeforeClose = void 0;
var utils_1 = require("@workspace/utils");
var useIframePidgetPromptBeforeClose = function (workspaceUrl) {
    var isValidOrigin = function (maybeOrigin) {
        return utils_1.workspaceUrls.includes(maybeOrigin);
    };
    var setPromptBeforeClose = function (bool) {
        // check origin from whitelist
        if (isValidOrigin(workspaceUrl)) {
            var message = {
                type: "SetPromptBeforeClose",
                allowCloseWithoutPrompt: !bool
            };
            window.parent.postMessage(JSON.stringify(message), workspaceUrl);
        }
    };
    return { setPromptBeforeClose: setPromptBeforeClose };
};
exports.useIframePidgetPromptBeforeClose = useIframePidgetPromptBeforeClose;
